module.exports = __webpack_public_path__ + "static/media/TypewriterCondensed.2b1ac338.woff";